import { useEffect, useState } from "react";
import { Element } from "react-scroll";
import APIDocImage from "../../../assets/img/code.jpg";
// import AiDocsImage from "../../../assets/svg/apiDocs.svg";
import { values } from "../../../constants";
import { chunk } from "../../../utils";

import {
  ApiDetails,
  ApiDocImage,
  ApiDocsContainer,
  ApiDocsImages,
  Container,
  MainWrapper,
  SubTitle,
  SubTitles,
  Title,
  Wrapper,
} from "./ApiDocs.elements";
function ApiSession() {
  const [width, setWidth] = useState<any>();
  useEffect(() => {
    window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
  }, []);

  return (
    <>
      <Element name="API Docs" id="API Docs">
        <MainWrapper>
          <Wrapper>
            <Title>
              Well documented and easy-to-use API documentation for developers
            </Title>
            <SubTitle>
              We have the core abstractions, you can build tools to manage your
              deliveries with your own drivers or use our Delivery Services
              Gateway and let JIFFY handle the complexities of dealing with 3rd
              party delivery services.
            </SubTitle>
          </Wrapper>

          <ApiDocsContainer>
            {width < 500 ? (
              <>
                {chunk(values.slice(0, 8), 1)?.map((value) => {
                  return (
                    <ApiDetails>
                      {value.map((el, id) => {
                        return (
                          <Container
                            key={id}
                            className="h-[20px] py-2 rounded-3xl"
                          >
                            <SubTitles>{el.text}</SubTitles>
                          </Container>
                        );
                      })}
                    </ApiDetails>
                  );
                })}
              </>
            ) : width < 1024 ? (
              <>
                {chunk(values.slice(0, 8), 2)?.map((value) => {
                  return (
                    <ApiDetails>
                      {value.map((el, id) => {
                        return (
                          <Container
                            key={id}
                            className="h-[20px] py-2 rounded-3xl"
                          >
                            <SubTitles>{el.text}</SubTitles>
                          </Container>
                        );
                      })}
                    </ApiDetails>
                  );
                })}
              </>
            ) : (
              <>
                {chunk(values.slice(0, 8), 4)?.map((value) => {
                  return (
                    <ApiDetails>
                      {value.map((el, id) => {
                        return (
                          <Container
                            key={id}
                            className="h-[20px] py-2 rounded-3xl"
                          >
                            <SubTitles>{el.text}</SubTitles>
                          </Container>
                        );
                      })}
                    </ApiDetails>
                  );
                })}
              </>
            )}
          </ApiDocsContainer>

          <ApiDocsImages>
            <ApiDocImage src={APIDocImage} alt="jiffy cover" />
          </ApiDocsImages>
        </MainWrapper>
      </Element>
    </>
  );
}
export default ApiSession;
